<template>
    <v-row  @click="$router.push(link).catch(()=>{})" class="headline2">
        <v-col>
            <v-icon size="22px" class="menu_active pr-2">
                mdi-{{icon}}
            </v-icon>
            {{title}}
        </v-col>
        <v-col class="col-5 font18 text-end">
          <v-icon>
            mdi-chevron-right-circle-outline
          </v-icon>
        </v-col>
    </v-row>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MenuItem',
  props: ['icon', 'title', 'link'],
  data () {
    return {
      member: null,
      profile: null
    }
  },
  async mounted () {
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MenuItem.vue